import React from 'react'
import styled from 'styled-components'
import { useStoreState } from 'easy-peasy'
import Text from '../utils/Text'
import BtnAction from '../components/form/BtnAction'

const Title = styled.h3`
  font-size: 50px;
  padding-top: 40px;
  padding-bottom: 30px;
  line-height: 51px;
`

const TextContainer = styled.div`
  padding-top: 2rem;
  p {
    font-size: 20px;
    line-height: 34px;
    a {
      color: #414141;
      text-decoration: underline;
    }
  }
`

export default function Thanks({ step }) {
  const [status, { success, error }] = useStoreState(state => [
    state.form.status,
    state.steps.pages[step],
  ])

  return (
    <div className="col-sm-offset-2 col-sm-8">
      {(() => {
        switch (status) {
          case 'success':
            return (
              <>
                <Title>{success.title}</Title>
                <TextContainer>
                  <Text id={success.text} />
                </TextContainer>
              </>
            )
          case 'error':
          default:
            return (
              <>
                <Title>
                  <Text id={error.title} />
                </Title>
                <TextContainer>
                  <Text id={error.text} />
                </TextContainer>
                <BtnAction
                  id="startAgain"
                  btn={error.btn}
                  action={() => window.location.reload()}
                />
              </>
            )
        }
      })()}
    </div>
  )
}
